import axios from "../axios";
import errorHandler from "../error-handler";

export const getSystemInfo = () =>
    new Promise((resolve, reject) =>
        axios
            .get(`/`)
            .then((response) => resolve(response.data))
            .catch((error) => reject(errorHandler(error)))
    );
